import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Sort } from '../shapes';


const SortSvg = (props) => (
  <g>
    <IconBounds />
    <Sort {...props} />
  </g>
);

SortSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

SortSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default SortSvg;
